import React, { useEffect, useState } from "react";
import { Layout, Menu, Button, Badge } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import {
  UserOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  WechatOutlined,
  FileProtectOutlined,
  LockOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";

import "./layout.css";
import UserList from "../pages/userList/userList";
import { callApi } from "../api/apiCaller";
import routes from "../api/routes";
import Loader from "../components/loader/loader";
import { GreenNotify, RedNotify } from "../helper/helper";
import { persistor } from "..";
import { clearAll } from "../redux/userDataSlice";
import TermsAndConditions from "../pages/terms/terms";
import PrivacyPolicy from "../pages/privacypolicy/privacyPolicy";
import TrainerList from "../pages/trainerList/trainer";
import ReportedPostsList from "../pages/reportPage/reportPost";

const { Header, Content, Sider } = Layout;

const LayoutDashboard = () => {
  const [isloading, setIsLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [hasUnreadMessages, setHasUnreadMessages] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const logOut = () => {
    const finalizeLogout = (message, isError = false) => {
      if (message) {
        isError ? RedNotify(message) : GreenNotify(message);
      }
      dispatch(clearAll());
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("deviceId");
      persistor.purge().then(() => {
        navigate("/login", { replace: true });
      });
    };

    callApi(
      "POST",
      routes.logOut,
      {},
      setIsLoading,
      (res) => {
        if (res.status === 200) {
          finalizeLogout(res.message);
        } else {
          finalizeLogout(res.message, true);
        }
      },
      (error) => {
        console.log("Logout error:", error);
        finalizeLogout("Logout failed", true);
      }
    );
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Loader loading={isloading} />
      <Sider
        style={{ background: "#0B1B2D" }}
        width={280}
        collapsible
        collapsed={collapsed}
        trigger={null}
      >
        <>
          <div
            style={{
              padding: "2rem 0",
              textAlign: "center",
              color: "white",
              fontSize: "3rem",
              borderBottom: "10px",
            }}
          >
            <h5>{collapsed ? "FB" : "FitBizZ"}</h5>
          </div>
          <Menu
            style={{ marginTop: "5rem" }}
            theme="dark"
            defaultSelectedKeys={["1"]}
            mode="inline"
          >
            <Menu.Item
              style={{ marginBottom: "2rem" }}
              onClick={() => navigate("/mother-list")}
              icon={<UserOutlined style={{ fontSize: "18px" }} />}
              key="10"
            >
              Mothers
            </Menu.Item>
            <Menu.Item
              style={{ marginBottom: "2rem" }}
              onClick={() => navigate("/trainer-list")}
              icon={<UserOutlined style={{ fontSize: "18px" }} />}
              key="11"
            >
              Trainers
            </Menu.Item>
            <Menu.Item
              style={{ marginBottom: "2rem" }}
              onClick={() => navigate("/report-post")}
              icon={<UserOutlined style={{ fontSize: "18px" }} />}
              key="12"
            >
              Reported Posts
            </Menu.Item>
            <Menu.Item
              style={{ marginBottom: "2rem" }}
              onClick={() => navigate("/terms-and-conditions")}
              icon={<FileProtectOutlined style={{ fontSize: "18px" }} />}
              key="170"
            >
              Terms & Conditions
            </Menu.Item>
            <Menu.Item
              style={{ marginBottom: "2rem" }}
              onClick={() => navigate("/privacy-policy")}
              icon={<LockOutlined style={{ fontSize: "18px" }} />}
              key="161"
            >
              Privacy Policy
            </Menu.Item>
            {/* <Menu.Item
              style={{ marginBottom: "2rem" }}
              onClick={() => navigate("/about")}
              icon={<InfoCircleOutlined style={{ fontSize: "18px" }} />}
              key="162"
            >
              About App
            </Menu.Item> */}

            <Menu.Item
              onClick={logOut}
              icon={<LogoutOutlined style={{ fontSize: "18px" }} />}
              key="89"
            >
              Log Out
            </Menu.Item>
          </Menu>
        </>
      </Sider>
      <Layout className="site-layout">
        <Content style={{ background: "#fff" }}>
          <Routes>
            <Route path="/mother-list" element={<UserList />} />
            <Route path="/trainer-list" element={<TrainerList />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/report-post" element={<ReportedPostsList />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutDashboard;
